import { Component, OnInit } from '@angular/core';
import { ClientService } from '../../../../services/client.service';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { AiToolExecution, AiTool } from '@rubii/entity/src/mdb-entities/ai';
import { JsonPopupComponent, JsonPopupData } from './json-popup.component';
import { Page } from '@rubii/frontend-common';

@Component({
  selector: 'app-ai-tool-executions',
  templateUrl: './ai-tool-executions.component.html',
  styleUrls: ['./ai-tool-executions.component.scss']
})
export class AiToolExecutionsComponent implements OnInit {

  toolId: number;
  toolName: string;
  toolExecutions: AiToolExecution[] = [];
  allToolExecutions: AiToolExecution[] = [];
  isLLMTool: boolean = false;
  page: Page;

  constructor(
    private client: ClientService,
    private route: ActivatedRoute,
    private dialog: MatDialog
  ) {
    this.page = new Page(1, 6, 0);
  }

  async ngOnInit() {
    this.toolId = this.route.snapshot.queryParams['tool_id'];

    if (this.toolId) {
      // Fetch tool information to get name and determine if it's LLM tool
      await this.loadToolInfo();

      // Fetch tool executions
      this.client.ai.listToolExecutions({ tool: this.toolId }).then((executions) => {
        this.allToolExecutions = executions;
        this.applyPagination();
        console.log(`toolExecutions`, JSON.stringify(this.allToolExecutions, null, 2));
      });
    }
  }

  async loadToolInfo() {
    try {
      const toolRunner = await this.client.ai.createToolRunner('');
      const tools = await toolRunner.listAvailableTools();
      const tool = tools.find(t => t._id == this.toolId);
      
      if (tool) {
        this.toolName = tool.name;
        this.isLLMTool = tool.extraObj && tool.extraObj['type'] === 'llm';
      }
    } catch (error) {
      console.error('Error loading tool info:', error);
    }
  }

  formatTimeElapsed(timeMs: number): string {
    if (!timeMs) return '-';
    return (timeMs / 1000).toFixed(2);
  }

  formatJson(data: any): string {
    if (!data) return '-';
    if (typeof data === 'string') {
      try {
        const parsed = JSON.parse(data);
        return JSON.stringify(parsed, null, 2);
      } catch (e) {
        return data;
      }
    }
    return JSON.stringify(data, null, 2);
  }

  getTruncatedJsonText(data: any): string {
    if (!data) return '-';
    
    let text = '';
    if (typeof data === 'string') {
      try {
        const parsed = JSON.parse(data);
        text = JSON.stringify(parsed);
      } catch (e) {
        text = data;
      }
    } else {
      text = JSON.stringify(data);
    }
    
    // Truncate to 50 characters and add ellipsis
    if (text.length > 50) {
      return text.substring(0, 50) + '...';
    }
    return text;
  }

  openJsonPopup(title: string, jsonData: any) {
    const dialogData: JsonPopupData = {
      title: title,
      json: jsonData
    };

    this.dialog.open(JsonPopupComponent, {
      data: dialogData,
      width: '800px',
      maxWidth: '95vw',
      maxHeight: '90vh'
    });
  }

  applyPagination() {
    this.page.total = this.allToolExecutions.length;
    
    if (this.allToolExecutions.length === 0) {
      this.page.pageId = 1;
      this.toolExecutions = [];
    } else {
      this.page.pageId = Math.min(this.page.pageId, Math.ceil(this.allToolExecutions.length / this.page.pageSize));
      this.toolExecutions = this.allToolExecutions.slice(
        (this.page.pageId - 1) * this.page.pageSize, 
        this.page.pageId * this.page.pageSize
      );
    }
  }

  pageChanged(event: PageEvent) {
    this.page.pageId = event.pageIndex + 1;
    this.page.pageSize = event.pageSize;
    this.applyPagination();
  }

}